import {
  TitleSectionContainer,
  VotingMetaText,
  VotingTitle,
} from '../../ui/Components/VotingTitle';
import { QuestionImage } from '../../ui/Components/QuestionImage';
import type { ModuleComponentProps } from '../types';

export function Content({ question }: ModuleComponentProps) {
  const { question: title, title_meta, image } = question;

  return (
    <TitleSectionContainer>
      <VotingMetaText meta={title_meta} mb="space2" />
      <VotingTitle title={title} mb="space6" />
      {image && (
        <QuestionImage
          crop={image.crop}
          largeImageUrl={image.presets.huge.url}
          mediumImageUrl={image.presets.medium.url}
          altText={image.alt_description}
        />
      )}
    </TitleSectionContainer>
  );
}
